import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '@state/root-state';
import type { AppDispatch } from '@state/dynamic-store';

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();